// import FsLightbox from 'fslightbox';

/* -------------------------------------------------------------------------- */
/*                             Mobile Menu Script                             */
/* -------------------------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
    var hamBurger = document.getElementById('mobileToggle');
    var menu = document.getElementById('mobileMenu');
    hamBurger?.addEventListener('click', () => {
 if (menu?.classList.contains('site-header__nav--mobile__menu--open')) {
        menu?.classList.remove('site-header__nav--mobile__menu--open');
        hamBurger?.classList.remove('is-active');
    }

    else {
        menu?.classList.add('site-header__nav--mobile__menu--open');
        hamBurger?.classList.add('is-active');
    }
    })
   
});

// document.addEventListener('DOMContentLoaded', function() {
//         refreshFsLightbox();
//     }

// );

/* -------------------------------------------------------------------------- */
/*                                  Sub menu                                  */
/* -------------------------------------------------------------------------- */


document.addEventListener("DOMContentLoaded", function () {
  var subcheck = document.getElementsByClassName("subcheck");

  for (var i = 0; i < subcheck.length; i++) {
    subcheck[i].addEventListener("click", function () {
      var parent = this.parentElement;
      var subMenu = this.nextElementSibling;
      var subMenuChildren = this.nextElementSibling.children.length;
      var heightBase = 40;

      if (parent.classList.contains("mobile-menu__item--parent--active") &&
        subMenu.classList.contains("mobile-menu__sub-menu--1")
      ) {
        parent.classList.remove("mobile-menu__item--parent--active");
        subMenu.style.height = "0px";
        this.classList.remove('subcheck__active');


      } else if (subMenu.classList.contains("mobile-menu__sub-menu--1")) {
        parent.classList.add("mobile-menu__item--parent--active");
        subMenu.style.height = heightBase * subMenuChildren + "px";
        this.classList.add('subcheck__active');

      } else if (parent.classList.contains("mobile-menu__item--parent--active") && subMenu.classList.contains("mobile-menu__sub-menu--2")) {
        parent.classList.remove("mobile-menu__item--parent--active");

        this.parentElement.parentElement.style.height = heightBase * this.parentElement.parentElement.children.length + "px";
        this.nextElementSibling.style.height = "0px";
         this.classList.remove('subcheck__active');


      } else {
        this.parentElement.parentElement.style.height = this.parentElement.parentElement.clientHeight + heightBase * subMenuChildren + "px";
        this.nextElementSibling.style.height = heightBase * subMenuChildren + "px";
        parent.classList.add("mobile-menu__item--parent--active");
         this.classList.add('subcheck__active');


      }
    });
  }

/* -------------------------------------------------------------------------- */
/*             Temporary fix for the weird acting of the sub-menu             */
/* -------------------------------------------------------------------------- */

    // var x = document.getElementsByClassName("mobile-menu__sub-menu mobile-menu__sub-menu--1")[0];
    // // x.id = "tempFix";
    // var id = document.getElementById("tempFix");
    // var sub_active = document.getElementsByClassName('mobile-menu__item--ancestor--active');
  
    // if (sub_active.length > 0) {
    //   // console.log("exists");
    //   id.setAttribute('style', 'height: auto');
    // } else {
    //   // console.log("doesn't exist");
    //   id.setAttribute('style', 'height: 0px');
    // }
});

/* -------------------------------------------------------------------------- */
/*                                Submenu tweak                               */
/* -------------------------------------------------------------------------- */

document.addEventListener('DOMContentLoaded', function (event) {
  var parents = document.getElementsByClassName('main-menu__item--parent  main-menu__sub-menu__item');

  for (var i = 0; i < parents.length; i++) {
    var submenu = parents[i].querySelector('.main-menu__sub-menu');
    parents[i].addEventListener('mouseenter', function () {
      submenu.classList.add('active');
    });
    parents[i].addEventListener('mouseleave', function () {
      submenu.classList.remove('active');
    });
  }
});

document.addEventListener("scroll", () => {
  // var stickyNav = document.querySelector(".pdf__meta");
  // // var staticNav = document.getElementById("staticNav");
  // // var mobileNav = document.getElementById("mobileNav");
  // var siteMain = document.querySelector("body"); //use site main as anchorpoint

  // // var elem = document.querySelector('#some-element');
  // // var bounding = staticNav?.getBoundingClientRect();
  // var bounding = siteMain?.getBoundingClientRect();
  // console.log(bounding?.top); //die getallentjes van jaap

  // if (bounding?.top <= -1400) {
  //   stickyNav?.classList.add("pdf__meta--sticky");
  // //   mobileNav.classList.add("site-nav__mobile--tabs__fixed");
  // } else if (bounding.top >= -1400) {
  //   stickyNav?.classList.remove("pdf__meta--sticky");
  // //   mobileNav.classList.add("site-nav__mobile--tabs__fixed");
  // }
});